import type * as React from 'react';
import type { JSX } from 'react';

interface FloatingProps {
  children: React.ReactNode;
}

const Floating = ({ children }: FloatingProps): JSX.Element => {
  return (
    <div className="mx-auto my-16 h-full max-w-104 rounded-2xl border border-line bg-surface px-10 pt-10 pb-10 shadow-paper max-md:my-6 max-md:px-5 [&_h2]:pt-0">
      {children}
    </div>
  );
};
export default Floating;
